export default __webpack_public_path__ + "static/angela-bitmoji-8f5e5e3f80157b983fce0a244a9ccef6.png";